// MUI's transition primitives — the numbers `theme.transitions` hands out.
//
// Its own module rather than a corner of `mui-collapse.tsx`, because a file
// that exports a component may only also export *components*: a shared
// constant or helper beside one breaks fast refresh
// (`react-refresh/only-export-components`). Any further ported transition
// belongs here too.

/**
 * `getAutoHeightDuration`, verbatim from `createTransitions.js:43-51`.
 *
 * What `timeout='auto'` resolves to: a duration derived from how far the
 * content has to travel, so a two-row branch and a forty-row one do not take
 * the same time. The curve is MUI's own —
 * https://www.desmos.com/calculator/vbrp3ggqet — and the 3000ms ceiling is
 * theirs as well.
 *
 * Exported so a test can state the expected duration from the same curve the
 * component uses, rather than from a number read off a sampled frame.
 */
export function autoHeightDuration(height: number): number {
  if (!height) return 0;
  const constant = height / 36;
  return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}

/** `theme.transitions.easing.easeInOut` (`createTransitions.js:15`). */
export const EASE_IN_OUT = "cubic-bezier(0.4, 0, 0.2, 1)";
